/* eslint-disable import/prefer-default-export */
// Routes through agenticApiClient so the call carries the BFF-minted
// `Authorization: Bearer <jwt>` the agents Function App requires
// (utils_router gates every route with Depends(get_current_principal)).
// A bare fetch with only `code`/`x-functions-key` 401s with
// AGENTIC_JWT_MISSING in environments that enforce the JWT (e.g. preview).
import { agenticPatch } from '../../utils/agenticApiClient';

export const updateRecordRole = async ({ caseId, recordRole }) => {
  const params = new URLSearchParams({
    record_role: recordRole,
    case_id: caseId,
  });
  return agenticPatch(`/status_update?${params.toString()}`);
};
